import React from 'react';
import ConfirmationDialog from '../../../../../../../components/Dialog/ConfirmationDialog';

const DeleteConfirmationDialog = ({ open, handleClose, onConfirm, documentName, isLoading }) => {
  return (
    <ConfirmationDialog
      open={open}
      handleClose={handleClose}
      message={`Are you sure you want to delete this document: "${documentName}"? This action cannot be undone.`}
      callback={onConfirm}
      loading={isLoading}
      btnTitle={"Delete"}
      title={"⚠️ Confirm Deletion"}
      btnColor="#B71D18" // Error red color
    />
  );
};

export default DeleteConfirmationDialog; 